import { render, staticRenderFns } from "./OptionsSelect.vue?vue&type=template&id=b8f63600&lang=pug&"
import script from "./OptionsSelect.vue?vue&type=script&lang=js&"
export * from "./OptionsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8f63600')) {
      api.createRecord('b8f63600', component.options)
    } else {
      api.reload('b8f63600', component.options)
    }
    module.hot.accept("./OptionsSelect.vue?vue&type=template&id=b8f63600&lang=pug&", function () {
      api.rerender('b8f63600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/OptionsSelect.vue"
export default component.exports